import CrudService from "./crud-service";
import http from "@/http-auth";

class ImagesService extends CrudService {
    getInitArgs(imageLabel) {
        return http.get(`/${this.apiName}/initargs/${imageLabel}`);
    }
}
export default new ImagesService("images");